import * as React from "react";
import { DeviceTypes, EDiarySessionScheduleItem, EDiarySubject, isModelWithError, Subject } from "../../../misc/api/apiTypes";
import LoadingWithMessage from "../../../misc/components/LoadingWithMessage";
import * as P230Messages from "../../../misc/api/DeviceLinkApi/P230In2itiveMessages";
import { ApiDevices, Device } from "../../../misc/api/DeviceLinkApi/Devices";
import { useCurrentStudyConfigurationContext } from "../../../Core/CurrentStudyConfigurationContext";
import { StudyScheduleSession } from "webportalclient";
import { useWebPortalApiClient, useWebPortalLegacyClient } from "../../../misc/api/WebPortalTokenClient";
import { ConfigureP230Device } from "../P230HomeSpirometry/P230HomeSpirometryConfiguration";
import { useAboutContextProvider } from "../../../Core/AboutContextProvider";

interface ConfigureP230In2itiveEDiaryProps {
    subject: Subject;
    sessionScheduleItems: StudyScheduleSession[];
    selectedDevice: Device;
    onError: (message: string) => void;
    onComplete: () => void;
}

export const ConfigureP230In2itiveEDiary = ({ subject, sessionScheduleItems, selectedDevice, onError, onComplete }: ConfigureP230In2itiveEDiaryProps) => {
    const { study } = useCurrentStudyConfigurationContext();
    const [status, setStatus] = React.useState(P230Messages.ConfiguringDevice);
    const client = useWebPortalApiClient();
    const legacyClient = useWebPortalLegacyClient();
    const { about } = useAboutContextProvider();
   
    const configure = async () => {
        try {
            const result = await ConfigureP230Device(client.client, legacyClient, study, subject, selectedDevice, sessionScheduleItems, about.UpdateServiceUri, setStatus, onError);

            if (result === false)
                return;

            onComplete();
        } catch (err) {
            return onError(err.message);
        }
    }

    React.useEffect(() => {
        const localConfigure = () => {
            configure();
        }

        localConfigure();
    }, []);

    return (
        <div className="modal-body">
            <LoadingWithMessage message={status} />
        </div>
    );
}



